import { useSelector } from 'react-redux';

import { ReduxState } from '../../../redux/types';
import { getGravatar } from '../../../utils/gravatar';
import Badge from '../Badge/Badge';
import { EmailContainer, FlexContainer, FlexPusher, NameContainer, StyledAvatar } from './styled';

/*
 * This component renders the profile information section in the sidebar.
 */

const ProfileInfoDrawer = () => {
    const userInfo = useSelector((state: ReduxState) => state.user);
    const { name, surname, email, type } = userInfo;

    const profileImage = getGravatar(email);

    return (
        <>
            <FlexContainer>
                <StyledAvatar alt={name} src={profileImage} />
                <FlexPusher />
                <Badge type={type} />
            </FlexContainer>

            <NameContainer variant='subtitle1' >
                {name} {surname}
            </NameContainer>

            <EmailContainer variant='caption' gutterBottom >
                {email}
            </EmailContainer>
        </>
    );
};



export default ProfileInfoDrawer;
